import { Box, CircularProgress, Typography } from "@mui/material"

function Loader({ message, ...other }) {
  return (
    <Box
      id="loader"
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 2,
        my: 4
      }}
      {...other}
    >
      <CircularProgress />
      <Typography paragraph id="text" variant="title" textAlign="center">
        {message}
      </Typography>
    </Box>
  )
}

export default Loader